export enum AbortActionEnum {
  THROW = 'THROW',
  RELOAD = 'RELOAD',
}
